import styled, { keyframes } from 'styled-components';

import CloseButton from '../../styles/CloseButton.styled';
import Icon from '../Icon/Icon';
import { colorMixin } from '../../styles/mixins';
import { scaleX, transitionTiming } from '../../styles/animations';
import { spacing } from '../../styles/spacing';

/**
 * Main styles for Alert Component
 */
const FitzyAlert = styled.div.attrs({
  role: 'alert',
  'aria-atomic': 'true'
})`
  display: flex;
  flex-wrap: wrap;
  position: relative;
  padding: ${spacing.l} 2.5rem ${spacing.l} 3rem;
  align-items: baseline;
  border-left: 5px solid ${({ theme, use }) => theme[use].border};
  box-shadow: ${({ theme }) =>
    `${theme.boxShadowSize} ${theme.boxShadowColor}`};
  ${colorMixin};
  width: 100%;

  h2 {
    font-weight: bold;
    margin-bottom: ${spacing.xs};
    margin-right: ${spacing.xl};
  }

  > div {
    margin-top: ${spacing.xs};
  }
`;

/**
 * Extra Styles for Alert Icon positioning
 */
const FitzyAlertIcon = styled(Icon)`
  left: ${spacing.l};
  position: absolute;
  top: ${spacing.lg};
`;

/**
 * Extra Styles for Alert Close Button
 */
const FitzyClose = styled(CloseButton)`
  position: absolute;
  top: ${spacing.lg};
  right: ${spacing.xl};
  height: ${spacing.xl};
  width: ${spacing.xl};

  &::after {
    border-radius: 50%;
    content: '';
    padding: ${spacing.l};
    position: absolute;
    transform: translate(-50%, -50%);
    left: 50%;
    top: 50%;
    transition: background-color ${transitionTiming};
  }

  &:hover {
    &::after {
      background-color: rgba(255, 255, 255, 0.1);
    }
  }
`;

const DismissBar = styled.div`
  position: absolute;
  height: 0.5rem;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.15);
  bottom: 0;
  left: 0;
  transform-origin: left;
  animation: ${scaleX} 5s linear forwards;
`;

/** @component */
export { FitzyAlert, FitzyClose, FitzyAlertIcon, DismissBar };
